export default "__VITE_ASSET__e546ebdb__"